import { useChatbotSettingsStore } from 'store/useChatbotSettingsStore'
import { useTemplateFormStore } from 'store/useTemplateFormStore'
import { useProjectStore } from 'store/useProjectStore'

export const useClearStateStores = () => {
  const { resetFormData: resetTemplateFormStore } = useTemplateFormStore()
  const { reset: resetChatbotSettingsStore } = useChatbotSettingsStore()
  const { reset: resetProjectStore } = useProjectStore()

  const clearStateStores = () => {
    resetTemplateFormStore()
    resetChatbotSettingsStore()
    resetProjectStore()
  }

  return { clearStateStores }
}
